var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        { staticClass: "primary", attrs: { dark: "" } },
        [
          _c("v-toolbar-title", { staticClass: "align-self-center" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { outline: "", color: "white" },
              on: { click: _vm.newItem }
            },
            [
              _c("v-icon", { attrs: { left: "", light: "" } }, [
                _vm._v("note_add")
              ]),
              _vm._v("New Item\n    ")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { fluid: "", "grid-list-md": "" } },
        [
          _c("v-data-iterator", {
            attrs: {
              items: _vm.items,
              "rows-per-page-items": _vm.rowsPerPageItems,
              pagination: _vm.pagination,
              "content-tag": "v-layout",
              "hide-actions": "",
              row: "",
              wrap: ""
            },
            on: {
              "update:pagination": function($event) {
                _vm.pagination = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function(props) {
                  return [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "", md4: "", lg3: "" } },
                      [
                        _c("user-class-card", {
                          attrs: { id: props.item, section: _vm.section },
                          on: { deleteNull: _vm.removeNull }
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-383bd869", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-383bd869","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-class/userTables.vue
// module id = null
// module chunks = 